import { HelpCircle, Play } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useArchViz } from "./ArchVizContext";
import { LegendDialog } from "./Legend";
import { LevelSummaryDialog } from "./LevelSummary";
import { VersionsDialog } from "./VersionsDialog";

export function ArchVizDialogs() {
  const { state, dispatch, extras } = useArchViz();
  const arch = state.architecture;
  const close = () => dispatch({ type: "CLOSE_DIALOG" });
  const onChange = (open: boolean) => {
    if (!open) close();
  };

  return (
    <>
      <LevelSummaryDialog open={state.openDialog === "summary"} onOpenChange={onChange} />
      <LegendDialog open={state.openDialog === "legend"} onOpenChange={onChange} />

      <Dialog open={state.openDialog === "flows"} onOpenChange={onChange}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-base">
              <Play className="h-4 w-4 text-muted-foreground" /> Flows
            </DialogTitle>
          </DialogHeader>
          <ul className="space-y-1 max-h-[60vh] overflow-y-auto -mx-1">
            {(arch?.dataFlows ?? []).map((f) => (
              <li key={f.id}>
                <button
                  type="button"
                  onClick={() => {
                    close();
                    dispatch({ type: "START_FLOW", flowId: f.id });
                  }}
                  className="w-full text-left flex items-start gap-2 px-2 py-2 rounded hover:bg-muted/50"
                >
                  <Play className="h-3.5 w-3.5 mt-0.5 text-muted-foreground shrink-0" />
                  <span className="text-sm">{f.label}</span>
                </button>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>

      <Dialog open={state.openDialog === "questions"} onOpenChange={onChange}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-base">
              <HelpCircle className="h-4 w-4 text-muted-foreground" /> Questions
            </DialogTitle>
          </DialogHeader>
          <ul className="space-y-1 max-h-[60vh] overflow-y-auto -mx-1">
            {(arch?.questions ?? []).map((q) => (
              <li key={q.id}>
                <button
                  type="button"
                  onClick={() => {
                    close();
                    dispatch({ type: "SELECT_NODE", nodeId: `question:${q.id}` });
                  }}
                  className="w-full text-left flex items-start gap-2 px-2 py-2 rounded hover:bg-muted/50"
                >
                  <HelpCircle className="h-3.5 w-3.5 mt-0.5 text-muted-foreground shrink-0" />
                  <span className="text-sm">{q.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>

      {extras.solutionSlug && (
        <VersionsDialog
          slug={extras.solutionSlug}
          open={state.openDialog === "versions"}
          onOpenChange={onChange}
        />
      )}
    </>
  );
}
